import React from "react";
import styled from "styled-components";

function MaxContent(props) {
    const MaxContent = styled.div`
    width: 80vw;
    height: 100%;
    `;
  return (
    <MaxContent>
        {props.children}
    </MaxContent>
  );
}

export default MaxContent;
